













import { Prop, Vue, Component } from "vue-property-decorator";

@Component
export default class ImportErrorList extends Vue {
  @Prop({ default: () => [] }) errors?: string[];
}
